/* ws-compact.js – C8 5 okt: lange collectie-omschrijving inklappen met "Lees meer" (tekst blijft in de HTML voor SEO). */
(function () {
  function init() {
    var els = document.querySelectorAll('.collection-banner__content .rte');
    for (var i = 0; i < els.length; i++) setup(els[i], i);
  }
  function setup(rte, i) {
    if (rte.dataset.wsc) return;
    rte.dataset.wsc = '1';
    var mobile = window.matchMedia('(max-width: 768px)').matches;
    var limit = mobile ? 170 : 260;
    if (rte.scrollHeight <= limit + 90) return;
    if (!rte.id) rte.id = 'wsc-desc-' + i;
    rte.style.setProperty('--wsc-h', limit + 'px');
    rte.classList.add('wsc-clamp');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wsc-more';
    btn.setAttribute('aria-controls', rte.id);
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Lees meer';
    btn.addEventListener('click', function () {
      var open = rte.classList.toggle('wsc-clamp');
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      btn.textContent = open ? 'Lees meer' : 'Minder tonen';
      if (open) rte.scrollIntoView({ block: 'nearest' });
    });
    rte.parentNode.insertBefore(btn, rte.nextSibling);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ws-compact.js – megamenu: klein paneel (.wm-mini) altijd binnen de viewport houden */
(function () {
  var mq = window.matchMedia('(min-width: 769px)');
  function place(li) {
    var mini = li.querySelector(':scope > .wm-mini');
    if (!mini || !mq.matches) return;
    mini.style.left = ''; mini.style.right = ''; mini.style.transform = '';
    var vw = document.documentElement.clientWidth, r = li.getBoundingClientRect(), w = mini.offsetWidth;
    var left = Math.max(12, Math.min(r.left + r.width / 2 - w / 2, vw - 12 - w));
    mini.style.left = Math.round(left - r.left) + 'px';
    mini.style.right = 'auto';
    mini.style.transform = 'none';
  }
  function bind() {
    var lis = document.querySelectorAll('.main-nav > li');
    for (var i = 0; i < lis.length; i++) {
      (function (li) {
        if (li.dataset.wscm) return;
        li.dataset.wscm = '1';
        li.addEventListener('mouseenter', function () { place(li); });
        li.addEventListener('focusin', function () { place(li); });
      })(lis[i]);
    }
  }
  function init() { bind(); setTimeout(bind, 1500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ws-compact.js – 10 okt: home-hero (SPHERE) lager in beeld, zodat de hele afzuiglamp die van kleur wisselt zichtbaar is. Foto en kleurmasker (svg) schuiven samen naar de bovenkant van de foto. */
(function () {
  function hero() {
    var img = document.querySelector('.ws-hero__img'), svg = document.querySelector('.ws-hero > svg');
    if (!img) return;
    img.style.objectPosition = '50% 0%';
    if (svg) svg.setAttribute('preserveAspectRatio', 'xMidYMin slice');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hero);
  else hero();
  window.addEventListener('load', hero);
})();

/* ws-compact.js – 10 okt: filterkaarten in de Wave-configurator met productfoto (zelfde opbouw als de motorstap), iets luxere uitstraling. Foto via zoeken op SKU, heel in beeld op een wit tegeltje. */
(function () {
  var CSS = '.wvc__card.wsf{flex-direction:row;align-items:center;gap:12px;padding:12px 14px;background:linear-gradient(180deg,#fff,#faf8f5);box-shadow:0 1px 2px rgba(0,0,0,.04)}' +
    '.wvc__card.wsf .wvc__m-img{flex:0 0 64px;width:64px;height:64px;box-sizing:border-box;border-radius:10px;background:#fff;border:1px solid #ece6dd;padding:8px}' +
    '.wvc__card.wsf .wvc__m-img img{width:100%;height:100%;object-fit:contain}' +
    '.wvc__card.wsf .wvc__m-img svg{width:26px;height:26px;color:#7a6e63}' +
    '.wvc__card.wsf .wvc__badge{position:absolute;top:-9px;left:12px;margin:0}' +
    '.wvc__card.wsf .wvc__pr{margin-top:4px;padding-top:0}' +
    '.wvc__card.wsf:has(input:checked){background:#fffaf5}';
  function img(sku) {
    return fetch('/search/suggest.json?q=' + encodeURIComponent(sku) + '&resources[type]=product&resources[limit]=5')
      .then(function (r) { return r.json(); })
      .then(function (d) { var p = (d.resources.results.products || []).filter(function (x) { return x.title.indexOf(sku) >= 0 && x.image; })[0]; return p ? p.image : ''; })
      .catch(function () { return ''; });
  }
  function run() {
    var step = document.querySelector('[data-wvc-filter-step]'); if (!step || step.dataset.wsf) return; step.dataset.wsf = '1';
    if (!document.getElementById('wsf-css')) { var s = document.createElement('style'); s.id = 'wsf-css'; s.textContent = CSS; document.head.appendChild(s); }
    step.querySelectorAll('.wvc__card').forEach(function (c) {
      var inp = c.querySelector('input'), box = document.createElement('span'), tx = document.createElement('span');
      box.className = 'wvc__m-img'; tx.className = 'wvc__m-tx';
      Array.prototype.slice.call(c.children).forEach(function (ch) { if (ch !== inp && !ch.classList.contains('wvc__badge')) tx.appendChild(ch); });
      c.appendChild(box); c.appendChild(tx); c.classList.add('wsf');
      var sku = inp && inp.dataset.sku;
      if (!sku) { box.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>'; return; }
      img(sku).then(function (u) { if (!u) { box.remove(); return; } var i = new Image(); i.alt = ''; i.loading = 'lazy'; i.src = u.split('?')[0] + '?width=160'; box.appendChild(i); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
})();

/* ws-compact.js – 11 okt: Airone niet meer in de zoeksuggesties (merk is uit het assortiment) */
(function () {
  function f() { var w = window.WAVE_SEARCH; if (w && w.popular) w.popular = w.popular.filter(function (x) { return !/airone/i.test(x); }); }
  f(); document.addEventListener('DOMContentLoaded', f); window.addEventListener('load', f);
})();

/* ws-compact.js – 11 okt: ontwerp onthouden. Keuzes in de Wave-configurator (kleur, leder, filter, motor, eigen kleur, afwerking, FRAME-kleur)
   worden 7 dagen in de browser bewaard en teruggezet als je terugkomt. Per model (data-model, 11 okt), zodat ze meegaan bij wisselen van breedte/uitvoering; kleurproducten (data-vk) per product. Niet als de link zelf keuzes meegeeft (?kleur= enz.). */
(function () {
  var root = document.querySelector('[data-wvc]'); if (!root) return;
  var VK = root.dataset.vk === '1', MOD = root.dataset.model || '';
  var KEY = (MOD && !VK) ? 'wsk:m:' + MOD.toLowerCase() : 'wsk:' + location.pathname.split('/products/')[1], TTL = 7 * 864e5, busy = false, ready = false;
  function scope() { return Array.prototype.slice.call(document.querySelectorAll('[data-wvc] input, .wvs-prev input, [data-wvf-txt], input[name^="wvf-"]')); }
  function save() {
    if (busy || !ready) return;
    var s = { t: Date.now(), r: {}, x: {} };
    scope().forEach(function (i) {
      if (i.type === 'radio') { if (i.checked && i.name) { var g = document.querySelectorAll('input[type=radio][name="' + i.name + '"]'); s.r[i.name] = { i: Array.prototype.indexOf.call(g, i), l: i.dataset.label || '' }; } }
      else if (i.type === 'text' || i.type === 'search' || i.hasAttribute('data-wvf-txt')) { var k = i.name || (i.hasAttribute('data-wvf-txt') ? 'wvf-txt' : ''); if (k) s.x[k] = i.value; }
    });
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
  }
  function fire(el, t) { el.dispatchEvent(new Event(t, { bubbles: true })); }
  function apply(s) {
    busy = true;
    Object.keys(s.r).forEach(function (n) {
      var g = document.querySelectorAll('input[type=radio][name="' + n + '"]'), v = s.r[n], el = null;
      if (typeof v === 'number') el = g[v];
      else if (v) { Array.prototype.forEach.call(g, function (x) { if (!el && v.l && x.dataset.label === v.l) el = x; }); if (!el && !v.l) el = g[v.i]; }
      if (el && !el.disabled && !el.checked) { el.checked = true; fire(el, 'change'); fire(el, 'input'); }
    });
    Object.keys(s.x).forEach(function (n) {
      var el = n === 'wvf-txt' ? document.querySelector('[data-wvf-txt]') : document.querySelector('input[name="' + n + '"]');
      if (el && s.x[n] && el.value !== s.x[n]) { el.value = s.x[n]; fire(el, 'input'); fire(el, 'change'); }
    });
    busy = false;
  }
  function vkp() { if (!VK) return; var b = root.querySelector('input[name="wvc-color"][value=""]'), p = b && b.parentNode.querySelector('.wvc__pr'); if (p) p.textContent = 'Wave Colour Collection'; }
  function restore() {
    vkp(); setTimeout(vkp, 800);
    if (/[?&](kleur|leder|filter)=/.test(location.search)) { ready = true; return; }
    var s; try { s = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { s = null; }
    if (!s || Date.now() - s.t > TTL) { ready = true; return; }
    apply(s); setTimeout(function () { apply(s); }, 400); setTimeout(function () { apply(s); ready = true; save(); }, 1200);
  }
  document.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('input')) setTimeout(save, 0); }, true);
  document.addEventListener('input', function (e) { if (e.target && e.target.matches && e.target.matches('input[type=text],[data-wvf-txt]')) setTimeout(save, 0); }, true);
  if (document.readyState === 'complete') setTimeout(restore, 300); else window.addEventListener('load', function () { setTimeout(restore, 300); });
})();
